import {createReducer} from '@reduxjs/toolkit'
import {getStaticMapUrl as getStaticMapUrlAction} from '../actions/static-map'

const defaultState = null

export const staticMapUrl = createReducer(defaultState, builder => {
  builder.addCase(getStaticMapUrlAction.fulfilled, (_state, action) => action.payload)
})
